export const superAdminUrl =
  process.env.SUPER_ADMIN_URL || "http://localhost:3001/api";
